let creators = [];
let recommendations = [];
let connections = [];

export function setCreators(newCreators) {
  creators = newCreators;
}

export function getCreators() {
  return creators;
}

export function setRecommendations(newRecommendations) {
  recommendations = newRecommendations;
}

export function getOldRecommendations() {
  return recommendations;
}

export function setConnections(newConnections) {
  connections = newConnections;
}

export function getCachedConnections() {
  return connections;
}
